import { render, staticRenderFns } from "./LogsEventsDatatable.vue?vue&type=template&id=41db8820&scoped=true"
import script from "./LogsEventsDatatable.vue?vue&type=script&lang=js"
export * from "./LogsEventsDatatable.vue?vue&type=script&lang=js"
import style0 from "./LogsEventsDatatable.vue?vue&type=style&index=0&id=41db8820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db8820",
  null
  
)

export default component.exports